import type { Release } from "@packages/commons";

/** Reads the release out of whatever a release mutation or subresource call returned. */
export const extractRelease = (value: unknown, fallback: Release): Release => {
  const record =
    value && typeof value === "object"
      ? (value as Record<string, unknown>)
      : {};
  const payload =
    record.payload && typeof record.payload === "object"
      ? (record.payload as Record<string, unknown>)
      : undefined;
  const data = record.data ?? payload?.data ?? value;
  return data && typeof data === "object" && "id" in data
    ? (data as Release)
    : fallback;
};
